<template>
    <div>
        <block v-if="loading"></block>
        
        <div class="d-flex flex-wrap align-self-center justify-end mb-3">
            
            <!--v-bottom-sheet v-model="showFilter" inset>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="orange" dark v-bind="attrs" v-on="on">{{$t('vwinvoices_cfilter')}}
                    </v-btn>
                </template>
                <v-sheet class="text-center">
                    <v-btn class="mt-6" text color="error" @click="showFilter = !showFilter">{{$t('vwinvoices_close')}}
                    </v-btn>
                    <v-btn class="mt-6" text color="primary"
                           @click.prevent="getAllInvoices">{{$t('vwinvoices_cfilter')}}
                    </v-btn>
                    <div class="my-3 pa-4">
                        <div>
                            <date-picker :label="$t('vwinvoices_cfromdate')"
                                         @dateSelected="(param) => filter.start = moment(param).format('YYYY/MM/DD')"></date-picker>
                            <date-picker :label="$t('vwinvoices_ctodate')"
                                         @dateSelected="(param) => filter.end = moment(param).format('YYYY/MM/DD')"></date-picker>
                            <v-select outlined dense  v-model="filter.type" attach
                                      :items="filterType"
                                      item-text="name" item-value="key"
                                      :label="$t('vwinvoices_cinvoicetype')">

                            </v-select>
                            <v-checkbox v-model="filter.bill"
                                        :label="$t('vwinvoices_onlyshowpendingtobill')"
                            ></v-checkbox>
                            <v-checkbox v-model="filter.pay"
                                        :label="$t('vwinvoices_onlyshowpendingtopay')"
                            ></v-checkbox>
                            <v-checkbox v-model="filter.onlunull"
                                        :label="$t('vwinvoices_onlyshownullfied')"
                            ></v-checkbox>
                        </div>

                    </div>

                </v-sheet>
            </v-bottom-sheet-->
        </div>
     

        <div class="background rounded-lg">
            <div class="px-4">
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <span class="text-h6">Descarga de archivos</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card rounded="lg">
                                <v-card-text class="px-0 pt-0">
                                    <date-filter
                                        @filtered-data="dateFilterHandler"
                                        @reset-data="getAllInvoices"
                                        :dataToFilter="invoices"
                                        :search="{ ...this.filter, showAllRecords: this.showAllRecords }"
                                        :componentToFilter="'HistoryR2'"
                                        nameOfDate="History"
                                        :filterEndpoint="$API.invoicesr2.getInvoices"
                                        :isFilteredByOutsource="isFiltered"
                                    >
                                        <template #default="{ startDate: start, endDate: end }">
                                            <PrintPdfJsonR2
                                                :data="invoices" @setLoading="(e) => loading = e "
                                                :is-r2-invoice="true"
                                                :reloadData="async({ withJSON }) => await reloadDataByDate({ withJSON, start, end })"
                                                @displaySuccessAlert="() => showAlert('success', 'Descarga exitosa', 'Documentos descargados con éxito.')"
                                                @displayErrorAlert="() => showAlert('danger', 'Error al imprimir', 'Ha ocurrido un error al imprimir, por favor intente de nuevo. si el problema persiste contacte al administrador del sistema.')"
                                            />
                                        </template>
                                    </date-filter>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <div class="mt-10 mt-md-8">
                <GeneralFilter 
                    class="mt-0" 
                    :breakline="true" 
                    :filterEndpoint="$API.invoicesr2.getInvoices" 
                    :columnsFilterEndpoint="$API.invoicesr2.getInvoices" 
                    :search="{ ...this.filter, showAllRecords: this.showAllRecords }"
                    :columns.sync="filterColumns"
                    :advancedFilter="true"
                    prefix-column
                    @emptyFilter="clearFilter" 
                    @filtered="filterHandler" 
                    :isAutoScrolled="true"
                    @loading="changeLoading"
                    :showAllRecordsToggle="true"
                    :showAllRecords="showAllRecords"
                    :alternativeColumnsFilterStyle="true"
                    @onShowAllRecordsChange="onShowAllRecordsChange"
                >
                        <!-- 
                        @displayErrorAlert="(e) => showAlert('danger', 'Error al imprimir', e)"
                    --> 
                    <DxDataGrid :data-source="invoices" key-expr="CodigoGeneracion" @exporting="onExporting"
                        :scrolling="{ useNative: true }"    
                        :column-auto-width="true"
                        :paging="{ enabled: false }" 
                        style="max-height: 600px;"
                    >
                        <DxExport :enabled="true"/>
                        <DxPaging :page-size="10"/>
                        <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                        <DxColumn data-field="InvoiceDateFormatted" width="100px" caption="Fecha de la Factura"></DxColumn>
                        <DxColumn data-field="InvoiceHour" width="100px" caption="Hora de la Factura"></DxColumn>
                        <!-- <DxColumn cell-template="hor-emi" width="100px" caption="Hora de la Factura"></DxColumn> -->
                        <!--DxColumn data-field="IdentificacionHorEmi" width="100px" caption="Hora de la Factura"></DxColumn-->
                        <!-- <DxColumn cell-template="tipo-documento" caption="Tipo de Documento"></DxColumn>  -->
                        <DxColumn data-field="InvoiceType" caption="Tipo de Documento"></DxColumn> 
                        <!--DxColumn data-field="IdentificacionTipoDteDesc" caption="Tipo de Documento"></DxColumn-->
                        <DxColumn data-field="CustomerLegalName" caption="Nombre legal"></DxColumn>
                        <DxColumn data-field="TipoOperacion" caption="Forma de pago"></DxColumn>
                        <DxColumn data-field="Estado" width="150px" caption="Estado"></DxColumn>
                        <!-- <DxColumn cell-template="tipo-ambiente"  width="150px" caption="Ambiente"></DxColumn> -->
                        <DxColumn data-field="CodigoGeneracion" caption="Codigo Generación"></DxColumn>
                        <DxColumn data-field="NumeroControl" caption="Numero de Control"></DxColumn>
                        <DxColumn data-field="SelloRecepcion" caption="Sello Recepcion"></DxColumn>
                        <template #show-template="{ data: { data } }">
                            <a href="#" class="mx-1" @click.prevent.stop="printInvoice( data )">
                                <v-icon color="primary">mdi-printer</v-icon>
                            </a>
                        </template>
                    </DxDataGrid>
                </GeneralFilter>
                
            </div>
        </div>
        


        <!-- Show Invoice Modal -->
        <v-dialog v-model="showModal" scrollable max-width="75%" >
            <v-card v-if="showInvoice">
                <invoice-details
                    :hasPrintButtom="true"
                    :hasUpdateCustomerBtn="false"
                    @close="showModal = false;"
                    :invoice="showInvoice.data"
                    :key="showInvoice.data.ID_Invoice"
                ></invoice-details>
            </v-card>
        </v-dialog>

        <alerts style="z-index: 20000 !important;"
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        >
        </alerts>

        <PrintPosFaR2 :show-invoice="print.show" :dataProps="print" :key="reloadPrint" />

    </div>
</template>

<script>
    import { DxDataGrid, DxColumn, DxExport, DxPaging } from 'devextreme-vue/data-grid';
    import { Workbook } from 'exceljs';
    import { saveAs } from 'file-saver-es';
    import { exportDataGrid } from 'devextreme/excel_exporter';
    import InvoiceDetails from "./InvoiceDetails"; 
    import Block from "@/components/Block";
    import Alerts from "@/components/Alerts";
    import DateFilter from '../../components/DateFilter.vue';
    import GeneralFilter from '../../components/GeneralFilter.vue';
    import PrintPdfJsonR2 from '../../components/POS/PrintPdfJsonR2.vue';
    import moment from 'moment/moment';
    import PrintPosFaR2 from '../../components/ReportsAndPrintings/PrintPosFaR2.vue';

    export default {
        name: "HistoryR2",
        components: { PrintPdfJsonR2, InvoiceDetails, DxDataGrid, DxColumn, Block, Alerts, DxExport, DateFilter, GeneralFilter, DxPaging, PrintPosFaR2 },
        data() {
            return {
                loading: false,
                form: {},
                showFilter: false,
                showModal: false,
                invoices: [],
                showInvoice: null,
                printInvoiceFlag: false,
                filter: {},
                showAllRecords: false,
                filterType: [
                    {
                        name: 'CRÉDITO FISCAL', key: 'CCF',
                    }, {
                        name: 'CONSUMIDOR FINAL', key: 'FAF'
                    }, {
                        name: 'NOTA DE CREDITO', key: 'NC'
                    }, {
                        name: 'NOTA DE DÉBITO', key: 'ND'
                    }
                ],
                alert: {
                    type: "success",
                    show: false,
                    header: "",
                    body: "",
                },
                isFiltered: false,
                filterColumns: [
                    {
                        name: "CodigoGeneracion",
                        title: 'Código de generación',
                        value: '',
                        type: 'like'
                    },
                    {
                        name: "NumeroControl",
                        title: 'Número de control',
                        value: '',
                        type: 'like'
                    },
                    {
                        name: "CustomerLegalName",
                        title:  'Nombre Legal',
                        value: '',
                        type: 'like'
                    },
                    {
                        name: "InvoiceType",
                        title: 'Tipo de Documento',
                        value: '',
                        type: 'select',
                        options: [
                            { name: 'CONSUMIDOR FINAL', value: 'CONSUMIDOR FINAL' },
                            { name: 'CRÉDITO FISCAL', value: 'CRÉDITO FISCAL' },
                            { name: 'SUJETO EXCLUIDO', value: 'SUJETO EXCLUIDO' },
                            { name: 'EXPORTACIÓN', value: 'EXPORTACIÓN' },
                            { name: 'COMPROBANTE DE DONACIÓN', value: 'COMPROBANTE DE DONACIÓN' },
                            { name: 'NOTA DE REMISIÓN', value: 'NOTA DE REMISIÓN' },
                            { name: 'NOTA DE CRÉDITO', value: 'NOTA DE CRÉDITO' }
                        ]
                    },
                    {
                        name: "Estado",
                        title: 'Estado',
                        value: '',
                        type: 'select',
                        options: [
                            { name: 'INVALIDADO', value: 'INVALIDADO' },
                            { name: 'RECHAZADO', value: 'RECHAZADO' },
                            { name: 'CONTINGENCIA', value: 'CONTINGENCIA' },
                            { name: 'PROCESADO', value: 'PROCESADO' }
                        ]
                    },
                    {
                        name: 'InvoiceDate',
                        from: {
                            title: "Fecha Inicio",
                            value: "",
                        },
                        to: {
                            title: "Fecha Fin",
                            value: "",
                        },
                        type: 'between'
                    }
                ],
                print: {
                    show: false
                },
                invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito"],
                paymentMethod: ["Pendiente", "Efectivo", "Cheque", "Transferencia", "Tarjeta de Crédito", "Otro"],
                entidades: {
                    '14': {
                        emisor: 'emisor',
                        receptor: 'sujetoExcluido'
                    },
                    '15': {
                        emisor: 'donatario',
                        receptor: 'donante'
                    }
                },
                reloadPrint: 0
            }
        },
        watch: {
          'showModal'() {
              if (!this.showModal) this.showInvoice = null
          }
        },
        computed: {
            
        },
        mounted() {
         /* this.filter.ID_Business = JSON.parse(localStorage.getItem("user")).businessid || "" ; */
            this.getAllInvoices()
        },
        methods: {
            printInvoice( invoiceRecord ){
                try {
                    const { jsonFaMH: { dteJson }, respuestaMh: respuestaMhString, NumeroControl, InvoiceType: type, ID_R2_Invoice, jsonRecepcionDte: recepcionDte } = invoiceRecord;

                    const respuestaMh = JSON.parse( respuestaMhString );

                    const entidadEmisora = this.entidades[ dteJson.identificacion.tipoDte ]?.emisor ? this.entidades[ dteJson.identificacion.tipoDte ]?.emisor : 'emisor';
                    const entidadReceptora = this.entidades[ dteJson.identificacion.tipoDte ]?.receptor ? this.entidades[ dteJson.identificacion.tipoDte ]?.receptor : 'receptor';
    
                    this.assignBody( dteJson.cuerpoDocumento, dteJson.identificacion.tipoDte );
                    this.assignSummary( dteJson.resumen, dteJson.identificacion.tipoDte );
    
                    const iva = dteJson.resumen.tributos ? dteJson.resumen.tributos.find( current => current.codigo === '20' ) : {};
    
                    if(Object.keys( iva ).length > 0) {
                        if(iva.valor) {
                            dteJson.resumen.totalIva = iva.valor;
                        }
                        else {
                            dteJson.resumen.totalIva = 0;
                        }
                    }
                    else {
                        dteJson.resumen.totalIva = 0;
                    }
    
                    let invoiceDate = ''
    
                    if( respuestaMh.fhProcesamiento ) {
                        invoiceDate = respuestaMh.fhProcesamiento.slice(0, 10);
                    } else { 
                        const partsOfDate = dteJson.identificacion.fecEmi.split( '-' );
                        invoiceDate = `${ partsOfDate[ 2 ] }/${ partsOfDate[ 1 ] }/${ partsOfDate[ 0 ] }`
                    }
    
                    this.print = {
                        branch: JSON.parse(localStorage.getItem("branch")),
                        header: {
                            businessName: dteJson[ entidadEmisora ].nombre,
                            businessComercialName: dteJson[ entidadEmisora ].nombreComercial,
                            businessActivity: dteJson[ entidadEmisora ].descActividad.concat(' (', dteJson[ entidadEmisora ].codActividad, ')'),
                            businessAddress: dteJson[ entidadEmisora ].direccion.complemento,
                            businessPhone: dteJson[ entidadEmisora ].telefono,
                            businessMobile: dteJson[ entidadEmisora ].celular || dteJson[ entidadEmisora ].movil || '',
                            businessEmail: dteJson[ entidadEmisora ].correo,
                            businessNIT: dteJson[ entidadEmisora ].nit,
                            businessNRC: dteJson[ entidadEmisora ].nrc,
                            invoiceMHEnv: dteJson.identificacion.ambiente,
                            invoiceCodGen: respuestaMh.codigoGeneracion,
                            invoiceSelloRecepcion:  respuestaMh.selloRecibido,
                            invoiceNumControl: NumeroControl,
                            invoiceDate,
                            invoiceType: type,
                            invoiceID: ID_R2_Invoice,
                            invoiceModel: dteJson.identificacion.tipoModelo,
                            invoiceOperation: dteJson.identificacion.tipoOperacion,
                            invoiceMoney: dteJson.identificacion.tipoMoneda,
                            invoiceTypeDte: dteJson.identificacion.tipoDte,
                            invoicePayment: dteJson.resumen.pagos ? this.paymentMethod[parseInt(dteJson.resumen.pagos[0].codigo)] : '',
                            invoiceDocRelated: dteJson.documentoRelacionado,
                            invoiceDocs: dteJson.otrosDocumentos,
                            invoiceName: dteJson[ entidadReceptora ].nombre,
                            invoiceAddress: dteJson[ entidadReceptora ].direccion?.complemento || dteJson[ entidadReceptora ].complemento,
                            invoiceTypeDoc: dteJson[ entidadReceptora ].TipoDocumento,
                            invoiceNumDoc: dteJson[ entidadReceptora ].numDocumento,
                            invoiceNIT: dteJson[ entidadReceptora ].nit,
                            invoiceNRC: dteJson[ entidadReceptora ].nrc,
                            invoiceEntity: dteJson[ entidadReceptora ].nombreComercial,
                            invoiceEntityActivity: dteJson[ entidadReceptora ].descActividad?.concat(' (', dteJson[ entidadEmisora ].codActividad, ')'),
                            invoiceStatus: this.invoiceStatus[ dteJson.resumen.condicionOperacion ]
                        },
                        body: dteJson.cuerpoDocumento,
                        resume: dteJson.resumen,
                        jsonToExport: { ...dteJson, 
                            firmaElectronica: recepcionDte.documento,
                            selloRecibido: respuestaMh.selloRecibido
                        },
                    }
                } catch (error) {
                    console.log( error );
                } finally {
                    this.reloadPrint++;
                    this.print.show = true;
                }
            },
            assignBody( body, invoiceType ) {
                for( const index in body ) {
                    const { ventaExenta, ventaNoSuj, ventaGravada } = body[ index ];
                    body[ index ].ventaExenta = ventaExenta ? ventaExenta : 0 ;
                    body[ index ].ventaNoSuj = ventaNoSuj ? ventaNoSuj : 0 ;
                    body[ index ].ventaGravada =
                    ventaGravada ?
                        ventaGravada :
                        invoiceType === '14' ? 
                        body[ index ].compra :
                        0 ;
                }
            },
            assignSummary( summary, invoiceType ) {
                const { subTotalVentas } = summary;
                summary.subTotalVentas =
                    subTotalVentas ?
                    subTotalVentas :
                    invoiceType === '14' ? 
                        summary.subTotal :
                        0 ;
            },
            async reloadDataByDate(payload) {
                try {
                    this.loading = true
                    payload.start = moment(payload.start, "DD/MM/YYYY").format("YYYY-MM-DD")
                    payload.end = moment(payload.end, "DD/MM/YYYY").format("YYYY-MM-DD")
                    const response = await this.$API.invoicesr2.getInvoices(
                        { ...payload, ...this.filter, showAllRecords: this.showAllRecords })
                    this.dateFilterHandler(response)
                } catch(err) {
                    console.error(err)
                    this.showAlert(
                        "error",
                        "Error",
                        `Ha ocurrido un error al consultar la información: ${err}`
                        );
                } finally {
                    this.loading = false
                }
            },
            changeLoading(response) {
                this.loading = response
            },
            formatDateToHour(data) {
                const completeDate = new Date(data);
                const hour = completeDate.getHours();
                const minutes = completeDate.getMinutes();
                const seconds = completeDate.getSeconds();

                return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
            },
            filterHandler(response) {
                this.isFiltered = true;
                this.invoices = [...response.data];
            },
            dateFilterHandler(filteredData) {
                this.invoices = filteredData.data;
            },
            clearFilter(){
                this.isFiltered = false;
                this.getAllInvoices();
            },
            onExporting(e) {
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('HistorialDeFacturas');

                exportDataGrid({
                    component: e.component,
                    worksheet,
                    topLeftCell: { row: 4, column: 1 },
                }).then((cellRange) => {
                    const headerRow = worksheet.getRow(2);
                    headerRow.height = 30;
                    worksheet.mergeCells(2, 1, 2, 8);

                    headerRow.getCell(1).value = 'Historial de Facturas Procesadas';
                    headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
                    headerRow.getCell(1).alignment = { horizontal: 'center' };

                    const footerRowIndex = cellRange.to.row + 2;
                    const footerRow = worksheet.getRow(footerRowIndex);
                    worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

                    footerRow.getCell(1).value = '-';
                    footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
                    footerRow.getCell(1).alignment = { horizontal: 'right' };
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'HistorialDeFacturas.xlsx');
                    });
                });
                e.cancel = true;
            },

            closeAlert() {
                this.alert.show = false;

                if (this.alert.options == "reloadInvoices") {
                    this.getAllInvoices()
                }
            },

            showAlert(type, header, body, options = null) {
                type = type == null ? "danger" : type;
                this.alert.type = type;
                this.alert.header = header;
                this.alert.body = body;
                this.alert.show = true;
                this.alert.options = options != null ? options : null;
            },

            getAllInvoices() {
                this.loading = true
                const filterWithLimit = {
                    ...this.filter,
                    showAllRecords: this.showAllRecords
                };
                this.$API.invoicesr2.getInvoices(filterWithLimit)
                    .then(response => {
                        this.loading = false
                        this.invoices = response.data
                    })
            },

            consultBatchProcess() {
                this.loading = true
                const filterWithLimit = {
                    ...this.filter,
                    showAllRecords: this.showAllRecords
                };
                this.$API.invoices.consultBatchProcess(filterWithLimit).then(response => {
                    if(response?.status == 1){
                        this.loading = false

                        this.showAlert(
                        "success",
                        "Lotes consultados y facturas actualizadas",
                        "Se ha consultado lotes enviados por contingencia y se ha recibido respuesta, las facturas han sido actualizadas con su respectivo sello y estado de PROCESADAS o RECHAZADAS.",
                        "reloadInvoices"
                        ); 
                    }
                    else if(response?.status == -1){
                        this.loading = false

                        this.showAlert(
                        "warning",
                        "Advertencia",
                        `El Ministerio de Hacienda no ha dado una respuesta sobre el lote de contingencia enviado, favor intentar más tarde.
                        Si el error persiste, favor comunicarse a nuestro contact center.`,
                        "reloadInvoices"
                        ); 
                    }
                    else{
                        this.loading = false
                        
                        this.showAlert(
                        "success",
                        "Lotes consultados",
                        "No se encontro lotes enviados por contingencia recientes.",
                        "reloadInvoices"
                        );
                    }
                })
            },

            consultBatchProcess2() {
                this.loading = true
                const filterWithLimit = {
                    ...this.filter,
                    showAllRecords: this.showAllRecords
                };
                this.$API.invoices.consultBatchProcess2(filterWithLimit).then(response => {
                    if(response?.status == 1){
                        this.loading = false

                        this.showAlert(
                        "success",
                        "Lotes consultados y facturas actualizadas",
                        "Se ha consultado lotes enviados por contingencia y se ha recibido respuesta, las facturas han sido actualizadas con su respectivo sello y estado de PROCESADAS.",
                        "reloadInvoices"
                        ); 
                    }
                    else if(response?.status == -1){
                        this.loading = false

                        this.showAlert(
                        "warning",
                        "Advertencia",
                        `El Ministerio de Hacienda no ha dado una respuesta sobre el lote de contingencia enviado, favor intentar más tarde.
                        Si el error persiste, favor comunicarse a nuestro contact center.`,
                        "reloadInvoices"
                        ); 
                    }
                    else{
                        this.loading = false
                        
                        this.showAlert(
                        "success",
                        "Lotes consultados",
                        "No se encontro lotes enviados por contingencia recientes.",
                        "reloadInvoices"
                        );
                    }
                })
            },

            contingencyProcess() {
                this.loading = true
                const filterWithLimit = {
                    ...this.filter,
                    showAllRecords: this.showAllRecords
                };
                this.$API.invoices.contingencyProcess(filterWithLimit).then(response => {
                    let mensaje = ""
                    if (response?.eventoContingencia != null) {
                        mensaje += "RESULTADO DE EMISIÓN DE EVENTO DE CONTINGENCIA. <br/>";
                        mensaje += "Estado contingencia: " + response.eventoContingencia.estado + "<br/>";
                        mensaje += "Mensaje contingencía: " + response.eventoContingencia.mensaje + "<br/>";
                        mensaje += "Observaciones: <br/>"
                        if(response.eventoContingencia.observaciones.length == 0){
                            mensaje += "- Ninguna observación <br/>"
                        }
                        else{
                            for(let i = 0; i < response.eventoContingencia.observaciones.length; i++){
                                mensaje += "- "+ response.eventoContingencia.observaciones[i] + "<br/>"
                            }
                        }
                    }
                    else {
                        mensaje += "NO SE GENERO NINGÚN EVENTO DE CONTINGENCIA. <br/>";
                    }

                    if (response?.respuestasRecepcionLotes.length > 0) {
                        mensaje += "<br/>"
                        if (response?.respuestasRecepcionLotes.length > 5) {
                            mensaje += `SE EMITIERON ${response.respuestasRecepcionLotes.length} LOTES SATISFACTORIAMENTE`;
                        }
                        else {
                            mensaje += "RESULTADO DE EMISIÓN DE LOTES. <br/>";

                            for (let i = 0; i < response.respuestasRecepcionLotes.length; i++) {
                                mensaje += "- Codigo Lote: " + response.respuestasRecepcionLotes[i].codigoLote + "<br/>";
                                mensaje += "Mensaje: " + response.respuestasRecepcionLotes[i].descripcionMsg + "<br/><br/>";
                            }
                        }
                    }
                    else {
                        mensaje += "<br/>"
                        mensaje += "NO SE GENERO NINGÚN LOTE. <br/>";
                    }

                    this.loading = false
                    this.showAlert(
                        "successHtml",
                        "Proceso de contingencia completado",
                        mensaje
                    );
                })
                .catch((err) => {
                    console.log("VEAMOS", err)
                    this.loading = false
                    this.showAlert("warning", "Advertencia", "Ocurrio un problema al ejecutar la contingencia. ¡Por favor contáctarse con el administrador del sistema!")
                })
            },

            addNDorNC(data){
                data.data.IsNDorNC = true
                this.showInvoice = data 
                this.showModal = true
            },

            onShowAllRecordsChange(value) {
                console.log("Show all records changed to:", value);
                this.showAllRecords = value;
            }
        }
    }
</script>

<style scoped>
.hoveredDiv{
    cursor: pointer;
}

.hoveredDiv:hover{
    background-color: #4e9ed3 !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2) !important;
}

.hoveredDiv2{
    cursor: pointer;
}

.hoveredDiv2:hover{
    background-color: rgb(41, 182, 147) !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2) !important;
}

.btn-add{
  background-color: #00A178 !important;
  color: white;
}
.btnsave {
  background-color: #3498db !important;
  color: white;
}
.background {
    background: white !important;
    color: white;
}
.btn-wrap-text {
padding: 10px 16px; 
width: fit-content;
font-weight: 500;
font-size:0.875rem;
align-items: center;
    border-radius: 4px;
    display: inline-flex;
    flex: 0 0 auto;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    justify-content: center;
    outline: 0;
    position: relative;
    text-decoration: none;
    text-indent: 0.0892857143em;
    text-transform: uppercase;
    transition-duration: 0.28s;
    transition-property: box-shadow, transform, opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
   
}


@media screen and (max-width: 900px) {
    .item {
        padding-bottom: 20px;
    }
}



@media screen and (max-width: 521px) {
    .btn-padding {
        margin-bottom: 20px; 
    }
    .btn-wrap-text {
  
  text-align: center; 
  line-height: 1.5; 
  width: 100%; 
 
}

}


</style>
